export default __webpack_public_path__ + "static/media/call-off-order.bf7aac9a.svg";